import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import { PenIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

type Props = {
  text?: string
  header?: React.ReactNode
  className?: string
  onEditClick: () => void
}

const EditHeader = ({ text, header, className, onEditClick }: Props) => {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      {header ?? (
        <Typography variant="sub-heading" color={tailwindColors.black.DEFAULT}>
          {text}
        </Typography>
      )}
      <Badge
        size="flexible"
        icon={<PenIcon color={tailwindColors.grey.DEFAULT} />}
        variant="white"
        className="rounded"
        onClick={onEditClick}
      />
    </div>
  )
}

export default EditHeader
